import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    AppOutline,
    AppstoreOutline,
    BellOutline,
    UserOutline,
    UploadOutline
} from 'antd-mobile-icons';
import { getMessageCount } from './api';
import './style.scss';

export default function BottomNav() {
    const navigate = useNavigate();
    const location = useLocation();
    const [messageCount, setMessageCount] = useState({ auditCount: 0, noticeCount: 0 });

    // 获取消息未读数量
    const fetchMessageCount = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (!userInfo || !userInfo.user || !userInfo.user.id) {
                return;
            }

            const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
            const response = await getMessageCount({
                auditId: userInfo.user.id,
                time: currentDate
            });

            if (response && response.ok && response.data) {
                setMessageCount({
                    auditCount: response.data.auditCount || 0,
                    noticeCount: response.data.noticeCount || 0
                });
            }
        } catch (error) {
            console.error('获取消息数量失败:', error);
        }
    };

    // 组件加载时获取消息数量
    useEffect(() => {
        fetchMessageCount();

        // 监听消息计数更新事件
        const handleMessageCountUpdate = () => {
            fetchMessageCount();
        };
        window.addEventListener('messageCountUpdate', handleMessageCountUpdate);

        return () => {
            window.removeEventListener('messageCountUpdate', handleMessageCountUpdate);
        };
    }, []);

    const navItems = [
        { path: '/home', icon: AppOutline, text: '首页' },
        { path: '/demand-supply', icon: AppstoreOutline, text: '供求' },
        { path: '/publish', icon: UploadOutline, text: '发布', requireAuth: true },
        {
            path: '/message',
            icon: BellOutline,
            text: '消息',
            dot: (messageCount.auditCount + messageCount.noticeCount) > 0,
            requireAuth: true
        },
        { path: '/profile', icon: UserOutline, text: '我的', requireAuth: true }
    ];

    // 检查是否有 token
    const checkAuth = () => {
        const token = localStorage.getItem('token');
        return token && token !== '';
    };

    // 处理导航点击
    const handleNavClick = (item) => {
        // 如果需要认证且没有 token，跳转到登录页
        if (item.requireAuth && !checkAuth()) {
            navigate('/login');
            return;
        }

        // 否则正常跳转
        navigate(item.path);
    };


    return (
        <div className="bottom-nav">
            {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;

                return (
                    <div
                        key={item.path}
                        className={`nav-item ${isActive ? 'active' : ''}`}
                        onClick={() => handleNavClick(item)}
                    >
                        <div className="nav-item-icon-wrapper">
                            <Icon className="nav-item-icon" />
                            {item.dot && <div className="nav-dot"></div>}
                        </div>
                        <div className="nav-item-text">{item.text}</div>
                    </div>
                );
            })}
        </div>
    );
}
